/**
 * @generated SignedSource<<8185b7b4d569f922ad5783b4fa082601>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum ConfluenceInlineTaskStatus {
  COMPLETE = "COMPLETE",
  INCOMPLETE = "INCOMPLETE",
}
export interface InlineTasksByMetadata {
  accountIds?: InputMaybe<InlineTasksQueryAccountIds>;
  after?: InputMaybe<Scalars["String"]["input"]>;
  /** The date range for an Inline Tasks' Completed Date. Start dates and end dates can be null-able to represent no specified start or end boundary. */
  completedDateRange?: InputMaybe<InlineTasksQueryDateRange>;
  /** The date range for an Inline Tasks' Created Date. Start dates and end dates can be null-able to represent no specified start or end boundary. */
  createdDateRange?: InputMaybe<InlineTasksQueryDateRange>;
  /** The date range for an Inline Tasks' Due Date. Start dates and end dates can be null-able to represent no specified start or end boundary. */
  dueDate?: InputMaybe<InlineTasksQueryDateRange>;
  first: Scalars["Int"]["input"];
  /** A boolean value representing whether to return task on current page or on child pages as well */
  forCurrentPageOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  /** A boolean value representing whether or not a Task has a set due date. False indicates no due date set for a given task. */
  isNoDueDate?: InputMaybe<Scalars["Boolean"]["input"]>;
  pageIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
  /** Supported sort columns for a Task query are: `due date`, `assignee`, and `page title`. Supported sort columns are `ASC` or `DESC`. */
  sortParameters?: InputMaybe<InlineTasksQuerySortParameters>;
  spaceIds?: InputMaybe<Array<InputMaybe<Scalars["Long"]["input"]>>>;
  status?: InputMaybe<TaskStatus>;
}
export interface InlineTasksQueryAccountIds {
  assigneeAccountIds?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  completedByAccountIds?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  creatorAccountIds?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
}
/** The date range for an Inline Tasks Query Date. Start dates and end dates can be null-able to represent no specified boundary. */
export interface InlineTasksQueryDateRange {
  endDate?: InputMaybe<Scalars["Long"]["input"]>;
  startDate?: InputMaybe<Scalars["Long"]["input"]>;
}
export enum InlineTasksQuerySortColumn {
  ASSIGNEE = "ASSIGNEE",
  DUE_DATE = "DUE_DATE",
  PAGE_TITLE = "PAGE_TITLE",
}
export enum InlineTasksQuerySortOrder {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING",
}
export interface InlineTasksQuerySortParameters {
  sortColumn: InlineTasksQuerySortColumn;
  sortOrder: InlineTasksQuerySortOrder;
}
export enum TaskStatus {
  CHECKED = "CHECKED",
  UNCHECKED = "UNCHECKED",
}
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_createdBy_GraphQLUserInfo =
  {
    __typename?: "GraphQLUserInfo";
    accountId: string;
    displayName: string | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_assignedTo_GraphQLUserInfo_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_assignedTo_GraphQLUserInfo =
  {
    __typename?: "GraphQLUserInfo";
    accountId: string;
    displayName: string | null;
    profilePicture: TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_assignedTo_GraphQLUserInfo_profilePicture_Icon | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_body_ConfluenceContentBody =
  {
    __typename?: "ConfluenceContentBody";
    adf: string | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluenceBlogPost_links_ConfluenceBlogPostLinks =
  {
    __typename?: "ConfluenceBlogPostLinks";
    base: string | null;
    webUi: string | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluenceBlogPost_space_ConfluenceSpace_links_ConfluenceSpaceLinks =
  {
    __typename?: "ConfluenceSpaceLinks";
    base: string | null;
    webUi: string | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluenceBlogPost_space_ConfluenceSpace =
  {
    __typename?: "ConfluenceSpace";
    id: string;
    spaceId: string;
    name: string | null;
    links: TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluenceBlogPost_space_ConfluenceSpace_links_ConfluenceSpaceLinks | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluencePage_links_ConfluencePageLinks =
  {
    __typename?: "ConfluencePageLinks";
    base: string | null;
    webUi: string | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluencePage_space_ConfluenceSpace_links_ConfluenceSpaceLinks =
  {
    __typename?: "ConfluenceSpaceLinks";
    base: string | null;
    webUi: string | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluencePage_space_ConfluenceSpace =
  {
    __typename?: "ConfluenceSpace";
    id: string;
    spaceId: string;
    name: string | null;
    links: TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluencePage_space_ConfluenceSpace_links_ConfluenceSpaceLinks | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluenceBlogPost =
  {
    __typename: "ConfluenceBlogPost";
    id: string;
    blogPostId: string;
    title: string | null;
    links: TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluenceBlogPost_links_ConfluenceBlogPostLinks | null;
    space: TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluenceBlogPost_space_ConfluenceSpace | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluencePage =
  {
    __typename: "ConfluencePage";
    id: string;
    pageId: string;
    title: string | null;
    links: TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluencePage_links_ConfluencePageLinks | null;
    space: TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluencePage_space_ConfluenceSpace | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container =

    | TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluenceBlogPost
    | TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container_ConfluencePage;
export type TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask =
  {
    __typename?: "GraphQLInlineTask";
    id: string;
    taskId: string | null;
    status: ConfluenceInlineTaskStatus | null;
    createdAt: string | null;
    dueAt: string | null;
    createdBy: TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_createdBy_GraphQLUserInfo | null;
    assignedTo: TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_assignedTo_GraphQLUserInfo | null;
    body: TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_body_ConfluenceContentBody | null;
    container: TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask_container | null;
  };
export type TasksQuery_inlineTasks_InlineTasksQueryResult = {
  __typename?: "InlineTasksQueryResult";
  endCursor: string | null;
  inlineTasks: Array<TasksQuery_inlineTasks_InlineTasksQueryResult_inlineTasks_GraphQLInlineTask | null> | null;
};
export type TasksQuery_Query = {
  __typename?: "Query";
  inlineTasks: TasksQuery_inlineTasks_InlineTasksQueryResult | null;
};
export type TasksQueryVariables = Exact<{
  taskQuery: InlineTasksByMetadata;
}>;
export type TasksQuery = TasksQuery_Query;
